import { useDispatch } from "react-redux";
import { setCart } from "../redux";

export const useCheckCart = () => {
    const dispatch = useDispatch();

    const checkCart = async () => {
        const lastCart = JSON.parse(localStorage.getItem('cart_vanrah'));
        if (!lastCart) return

        let newCart = [];

        for (let prod of lastCart) {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/get/${prod.title_path}`);
            const res = await req.json();

            newCart.push({ ...prod, exist: res ? true : false });
        }
        dispatch(setCart(newCart));
    };
    return checkCart;
};